import LdsIcon from '../LdsIcon/index.jsx';

export default function ToastIcon({ variant, altText }) {
  if (
    variant === 'error'
    || variant === 'informative'
    || variant === 'success'
    || variant === 'warning'
  ) {
    return (
      <>
        <span className="sr-only">{`${altText}`}</span>
        <div className="lds-toast-icon icon inline">
          <LdsIcon
            name={getIcon(variant)}
            inline
            decorative
          />
        </div>
      </>
    );
  }
  return null;
}
function getIcon(variant) {
  switch (variant) {
    case 'error':
      return 'WarningCircleFill';
    case 'informative':
      return 'InfoFill';
    case 'neutral':
      return '';
    case 'success':
      return 'CheckCircleFill';
    case 'warning':
      return 'WarningFill';
    default:
      return '';
  }
}
